import { GraphQLError } from 'graphql';
import { GraphQLRequestContext } from 'graphql-request/build/esm/types';

import { GenericFunction } from 'utils/typescript.utils';

const ONE_MINUTE = 60000;

export enum StaleTime {
  FIVE_SECONDS = ONE_MINUTE / 12,
  THIRTY_SEC = ONE_MINUTE / 2,
  MINUTE = ONE_MINUTE,
  FIVE_MIN = 5 * ONE_MINUTE,
  FIFTEEN_MIN = 15 * ONE_MINUTE,
  THIRTY_MIN = 30 * ONE_MINUTE,
  ONE_HOUR = 60 * ONE_MINUTE,
  FOREVER = Infinity,
}

export enum RefetchTime {
  MINUTE = ONE_MINUTE,
  FIVE_MIN = 5 * ONE_MINUTE,
  FIFTEEN_MIN = 15 * ONE_MINUTE,
  FIVE_SECONDS = ONE_MINUTE / 12,
  FIVE_HUNDRED_MS = ONE_MINUTE / 120,
  ONE_SECOND = ONE_MINUTE / 60,
  TWO_SECONDS = ONE_MINUTE / 30,
}

export type QueryVariables<
  T extends GenericFunction,
  WithoutKeys extends string = 'locale',
> = Omit<Parameters<T>[0], WithoutKeys>;

type AppSyncError<ErrorDetail = string> = Pick<
  GraphQLError,
  'locations' | 'message' | 'path'
> & {
  errorInfo: {
    code?: string;
    response?: ErrorDetail;
    statusCode: number;
  };
  data: null | string;
  errorType: 'TicketingRequestError' | 'NotFound' | 'Unauthorized';
};

export type AppSyncGraphQLError<ErrorDetail = string> = {
  response: {
    data?: null;
    errors: Array<AppSyncError<ErrorDetail>>;
  };
  request: GraphQLRequestContext;
};
